import { Dropdown } from 'primereact/dropdown';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { Chart } from 'primereact/chart';
import { DashboardService as Service } from './DashboardService';
import { InputNumber } from 'primereact/inputnumber';
import { ToastService } from '@iamsoftware/react-hooks';

export default function Dashboard() {
  const backG1 = 'White';
  const [times, setTimes] = useState('THISFISCALYEAR')
  const [timesCircle, setTimesCircle] = useState('THISFISCALYEAR')
  const [amountTotal, setAmountTotal] = useState(null)
  const [statusAgreement, setStatusAgreement] = useState(null)
  const [textValue, setTextValue] = useState(6)
  const [assetData, setAssetData] = useState([])
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});
  const [chartCircleData, setChartCircleData] = useState({});
  const [chartCircleOptions, setChartCircleOptions] = useState({});
  const [overviewStats, setOverviewStats] = useState({
    totalAgreement: 0,
    signedAgreement: 0,
    pendingAgreement: 0,
    draftAgreement: 0
  });
  const [totalLastNMonth, setTotalLastNMonth] = useState(3);
  const [signedLastNMonth, setSignedLastNMonth] = useState(3);
  const [pendingLastNMonth, setPendingLastNMonth] = useState(3);
  const [draftLastNMonth, setDraftLastNMonth] = useState(3);

  const monthOptions = [
    { label: '1 tháng', value: 1 },
    { label: '3 tháng', value: 3 },
    { label: '6 tháng', value: 6 },
    { label: '12 tháng', value: 12 },
    { label: '24 tháng', value: 24 },
    { label: 'Năm nay', value: -1 }
  ];


  useEffect(() => {
    if (textValue) {
      const lineOptions = {
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          x: {
            ticks: {
              color: 'var(--text-color-secondary)'
            },
            grid: {
              color: 'var(--surface-border)'
            }
          },
          y: {
            ticks: {
              color: 'var(--text-color-secondary)'
            },
            grid: {
              color: 'var(--surface-border)'
            }
          }
        }
      };
      const lineData = {
        labels: new Array<any>(),
        datasets: [{
          label: 'Hợp đồng',
          data: new Array<any>(),
          fill: false,
          borderColor: '#42A5F5',
          tension: .4
        }]
      }
      Service.getIssuedQuantityPeriod(textValue).then(({ listData }) => {
        if (listData) {
          listData.forEach(item => {
            lineData.labels.push(item.label);
            lineData.datasets[0].data.push(item.value);
          })
          setChartData(lineData)
          setChartOptions(lineOptions)
        }
      }).catch(error => {
        setChartData(lineData)
        setChartOptions(lineOptions)
      })
    }
  }, [textValue]);

  useEffect(() => {
    if (timesCircle) {
      const { fromDate, thruDate } = getPeriodValue(timesCircle)
      const pieOptions: any = {
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              color: 'var(--text-color)',
              padding: 15
            }
          }
        }
      };
      const pieData = {
        labels: ['Đã sử dụng', 'Chưa sử dụng'],
        datasets: [
          {
            data: [0, 0],
            backgroundColor: [
              "#FF6384",
              "#36A2EB"
            ],
            hoverBackgroundColor: [
              "#FF6384",
              "#36A2EB"
            ]
          }
        ]
      };
      Service.getIssuedAndRemain(new Date(fromDate).getTime(), new Date(thruDate).getTime()).then(data => {
        pieData.datasets[0].data[0] = data.issuedAgreement
        pieData.datasets[0].data[1] = data.remainAgreement
        setChartCircleData(pieData)
        setChartCircleOptions(pieOptions)
      }).catch(error => {
        // Set default data on error
        setChartCircleData(pieData)
        setChartCircleOptions(pieOptions)
      })
    }
  }, [timesCircle]);


  const getPeriodValue = (period?: string) => {
    let fromDate = new Date();
    let thruDate = new Date();

    const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    const quarters = ['FISCALQUARTER1', 'FISCALQUARTER2', 'FISCALQUARTER3', 'FISCALQUARTER4'];

    if (period && months.indexOf(period) >= 0) {
      fromDate = moment().month(months.indexOf(period)).startOf('month').toDate();
      thruDate = moment().month(months.indexOf(period)).endOf('month').toDate();
    } else if ((period && quarters.indexOf(period) >= 0)) {
      fromDate = moment().quarter(quarters.indexOf(period) + 1).startOf('quarter').toDate();
      thruDate = moment().quarter(quarters.indexOf(period) + 1).endOf('quarter').toDate();
    } else {
      switch (period) {
        case 'TODAY':
          fromDate = moment().startOf('day').toDate();
          thruDate = moment().endOf('day').toDate();
          break;
        case 'THISWEEK':
          fromDate = moment().startOf('isoWeek').toDate();
          thruDate = moment().endOf('isoWeek').toDate();
          break;
        case 'THISWEEKTODATE':
          fromDate = moment().startOf('isoWeek').toDate();
          break;
        case 'THISMONTH':
          fromDate = moment().startOf('month').toDate();
          thruDate = moment().endOf('month').toDate();
          break;
        case 'THISMONTHTODATE':
          fromDate = moment().startOf('month').toDate();
          break;
        case 'THISFISCALQUARTER':
          fromDate = moment().startOf('quarter').toDate();
          thruDate = moment().endOf('quarter').toDate();
          break;
        case 'THISFISCALQUARTERTODATE':
          fromDate = moment().startOf('quarter').toDate();
          break;
        case 'THISFISCALYEAR':
          fromDate = moment().startOf('year').toDate();
          thruDate = moment().endOf('year').toDate();
          break;
        case 'THISFISCALYEARTODATE':
          fromDate = moment().startOf('year').toDate();
          break;
        case 'FIRSTSIXMONTH':
          fromDate = moment().startOf('year').toDate();
          thruDate = moment().month(5).endOf('month').toDate();
          break;
        case 'LASTSIXMONTH':
          fromDate = moment().month(6).startOf('month').toDate();
          thruDate = moment().endOf('year').toDate();
          break;
        case 'YESTERDAY':
          fromDate = moment().subtract(1, 'day').startOf('day').toDate();
          thruDate = moment().subtract(1, 'day').endOf('day').toDate();
          break;
        case 'LASTWEEK':
          fromDate = moment().subtract(1, 'week').startOf('isoWeek').toDate();
          thruDate = moment().subtract(1, 'week').endOf('isoWeek').toDate();
          break;
        case 'LASTMONTH':
          fromDate = moment().subtract(1, 'month').startOf('month').toDate();
          thruDate = moment().subtract(1, 'month').endOf('month').toDate();
          break;
        case 'LASTFISCALQUARTER':
          fromDate = moment().subtract(1, 'quarter').startOf('quarter').toDate();
          thruDate = moment().subtract(1, 'quarter').endOf('quarter').toDate();
          break;
        case 'LASTFISCALYEAR':
          fromDate = moment().subtract(1, 'year').startOf('year').toDate();
          thruDate = moment().subtract(1, 'year').endOf('year').toDate();
          break;
        case 'NEXTWEEK':
          fromDate = moment().add(1, 'week').startOf('isoWeek').toDate();
          thruDate = moment().add(1, 'week').endOf('isoWeek').toDate();
          break;
        case 'NEXTMONTH':
          fromDate = moment().add(1, 'month').startOf('month').toDate();
          thruDate = moment().add(1, 'month').endOf('month').toDate();
          break;
        case 'NEXTFISCALQUARTER':
          fromDate = moment().add(1, 'quarter').startOf('quarter').toDate();
          thruDate = moment().add(1, 'quarter').endOf('quarter').toDate();
          break;
        case 'NEXTFISCALYEAR':
          fromDate = moment().add(1, 'year').startOf('year').toDate();
          thruDate = moment().add(1, 'year').endOf('year').toDate();
          break;
      }
    }
    return { fromDate, thruDate };
  }

  useEffect(() => {
    if (times) {
      const { fromDate, thruDate } = getPeriodValue(times)
      Service.getDashboarhAmount(new Date(fromDate).getTime(), new Date(thruDate).getTime()).then(data => {
        setAmountTotal(data.number)
      }).catch(error => {
        setAmountTotal(0)
      })
    }
  }, [times]);

  useEffect(() => {
    Service.getDashboarhAsset().then(data => {
      setAssetData(data.assetList || [])
    }).catch(error => {
      setAssetData([])
    })

    Service.getStatusQuantity().then(data => {
      setStatusAgreement(data)
    }).catch(error => {
      setStatusAgreement({
        canceledAgreement: 0,
        createdAgreement: 0,
        completedAgreement: 0
      })
    })

    // Tính số tháng từ đầu năm nếu chọn "Năm nay" (-1)
    const getMonthValue = (value: number) => {
      if (value === -1) {
        // Tính số tháng từ đầu năm đến hiện tại
        const now = moment();
        const startOfYear = moment().startOf('year');
        return now.diff(startOfYear, 'months') + 1;
      }
      return value;
    };

    Service.getOverviewStatistics(
      getMonthValue(totalLastNMonth),
      getMonthValue(signedLastNMonth),
      getMonthValue(pendingLastNMonth),
      getMonthValue(draftLastNMonth)
    ).then(data => {
      setOverviewStats({
        totalAgreement: data.totalAgreement || 0,
        signedAgreement: data.signedAgreement || 0,
        pendingAgreement: data.pendingAgreement || 0,
        draftAgreement: data.draftAgreement || 0
      })
    }).catch(error => {
      setOverviewStats({
        totalAgreement: 0,
        signedAgreement: 0,
        pendingAgreement: 0,
        draftAgreement: 0
      })
    })
  }, [totalLastNMonth, signedLastNMonth, pendingLastNMonth, draftLastNMonth]);


  return (
    <div className="grid">
      {/* Thống kê tổng quan - 4 hộp ngang */}
      <div className="col-12 mb-5">
        <h3 className="mb-4" style={{ fontWeight: '600', fontSize: '1.5rem', color: 'var(--text-color)', letterSpacing: '-0.02em' }}>Thống kê tổng quan</h3>
        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
          <div style={{ flex: '1 1 calc(25% - 0.75rem)', minWidth: '200px' }}>
            <div className="card" style={{
              backgroundImage: 'linear-gradient(135deg, #1D976C 0%, #2fd38a 100%)',
              color: '#fff',
              borderRadius: '16px',
              padding: '1.25rem',
              textAlign: 'center',
              minHeight: '110px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              boxShadow: '0 4px 6px -1px rgba(29, 151, 108, 0.2), 0 2px 4px -1px rgba(29, 151, 108, 0.1)',
              border: 'none',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              cursor: 'pointer'
            }} onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(29, 151, 108, 0.3), 0 4px 6px -2px rgba(29, 151, 108, 0.2)';
              e.currentTarget.style.transform = 'translateY(-4px) scale(1.02)';
            }} onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(29, 151, 108, 0.2), 0 2px 4px -1px rgba(29, 151, 108, 0.1)';
              e.currentTarget.style.transform = 'translateY(0) scale(1)';
            }}>
              <div className="flex justify-content-between align-items-center mb-3">
                <span className="font-medium" style={{ fontSize: '0.875rem', color: '#fff', opacity: 0.95 }}>
                  Tổng tài liệu
                </span>
                <Dropdown
                  options={monthOptions}
                  value={totalLastNMonth}
                  onChange={(e) => setTotalLastNMonth(e.value)}
                  optionLabel="label"
                  optionValue="value"
                  style={{
                    width: '100px',
                    height: '32px'
                  }}
                  panelStyle={{
                    fontSize: '0.875rem',
                    padding: '4px 0',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    background: '#fff'
                  }}
                  pt={{
                    root: {
                      style: {
                        background: 'rgba(255, 255, 255, 0.25)',
                        borderRadius: '6px',
                        border: '1px solid rgba(255, 255, 255, 0.3)',
                        padding: '6px 10px',
                        height: '32px',
                        backdropFilter: 'blur(4px)'
                      }
                    },
                    input: {
                      style: {
                        padding: '0',
                        fontSize: '0.8rem',
                        color: '#fff',
                        fontWeight: '500'
                      }
                    },
                    trigger: {
                      style: {
                        color: '#fff',
                        width: '20px'
                      }
                    },
                    item: ({ context }: any) => ({
                      style: {
                        padding: '8px 12px',
                        fontSize: '0.875rem',
                        backgroundColor: context.selected ? '#e3f2fd' : 'transparent',
                        color: context.selected ? '#1976d2' : '#495057'
                      }
                    })
                  }}
                />
              </div>
              <div className="font-bold" style={{ fontSize: '2.5rem', lineHeight: '1', color: '#fff', fontWeight: '700' }}>{overviewStats.totalAgreement}</div>
            </div>
          </div>
          <div style={{ flex: '1 1 calc(25% - 0.75rem)', minWidth: '200px' }}>
            <div className="card" style={{
              backgroundImage: 'linear-gradient(135deg, #664dc9 0%, #9884ea 100%)',
              color: '#fff',
              borderRadius: '16px',
              padding: '1.25rem',
              textAlign: 'center',
              minHeight: '110px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              boxShadow: '0 4px 6px -1px rgba(102, 77, 201, 0.2), 0 2px 4px -1px rgba(102, 77, 201, 0.1)',
              border: 'none',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              cursor: 'pointer'
            }} onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(102, 77, 201, 0.3), 0 4px 6px -2px rgba(102, 77, 201, 0.2)';
              e.currentTarget.style.transform = 'translateY(-4px) scale(1.02)';
            }} onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(102, 77, 201, 0.2), 0 2px 4px -1px rgba(102, 77, 201, 0.1)';
              e.currentTarget.style.transform = 'translateY(0) scale(1)';
            }}>
              <div className="flex justify-content-between align-items-center mb-3">
                <span className="font-medium" style={{ fontSize: '0.875rem', color: '#fff', opacity: 0.95 }}>
                  Đã ký
                </span>
                <Dropdown
                  options={monthOptions}
                  value={signedLastNMonth}
                  onChange={(e) => setSignedLastNMonth(e.value)}
                  optionLabel="label"
                  optionValue="value"
                  style={{
                    width: '100px',
                    height: '32px'
                  }}
                  panelStyle={{
                    fontSize: '0.875rem',
                    padding: '4px 0',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    background: '#fff'
                  }}
                  pt={{
                    root: {
                      style: {
                        background: 'rgba(255, 255, 255, 0.25)',
                        borderRadius: '6px',
                        border: '1px solid rgba(255, 255, 255, 0.3)',
                        padding: '6px 10px',
                        height: '32px',
                        backdropFilter: 'blur(4px)'
                      }
                    },
                    input: {
                      style: {
                        padding: '0',
                        fontSize: '0.8rem',
                        color: '#fff',
                        fontWeight: '500'
                      }
                    },
                    trigger: {
                      style: {
                        color: '#fff',
                        width: '20px'
                      }
                    },
                    item: ({ context }: any) => ({
                      style: {
                        padding: '8px 12px',
                        fontSize: '0.875rem',
                        backgroundColor: context.selected ? '#e3f2fd' : 'transparent',
                        color: context.selected ? '#1976d2' : '#495057'
                      }
                    })
                  }}
                />
              </div>
              <div className="font-bold" style={{ fontSize: '2.5rem', lineHeight: '1', color: '#fff', fontWeight: '700' }}>{overviewStats.signedAgreement}</div>
            </div>
          </div>
          <div style={{ flex: '1 1 calc(25% - 0.75rem)', minWidth: '200px' }}>
            <div className="card" style={{
              backgroundImage: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
              color: '#fff',
              borderRadius: '16px',
              padding: '1.25rem',
              textAlign: 'center',
              minHeight: '110px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              boxShadow: '0 4px 6px -1px rgba(245, 158, 11, 0.2), 0 2px 4px -1px rgba(245, 158, 11, 0.1)',
              border: 'none',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              cursor: 'pointer'
            }} onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(245, 158, 11, 0.3), 0 4px 6px -2px rgba(245, 158, 11, 0.2)';
              e.currentTarget.style.transform = 'translateY(-4px) scale(1.02)';
            }} onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(245, 158, 11, 0.2), 0 2px 4px -1px rgba(245, 158, 11, 0.1)';
              e.currentTarget.style.transform = 'translateY(0) scale(1)';
            }}>
              <div className="flex justify-content-between align-items-center mb-3">
                <span className="font-medium" style={{ fontSize: '0.875rem', color: '#fff', opacity: 0.95 }}>
                  Đang chờ ký
                </span>
                <Dropdown
                  options={monthOptions}
                  value={pendingLastNMonth}
                  onChange={(e) => setPendingLastNMonth(e.value)}
                  optionLabel="label"
                  optionValue="value"
                  style={{
                    width: '100px',
                    height: '32px'
                  }}
                  panelStyle={{
                    fontSize: '0.875rem',
                    padding: '4px 0',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    background: '#fff'
                  }}
                  pt={{
                    root: {
                      style: {
                        background: 'rgba(255, 255, 255, 0.25)',
                        borderRadius: '6px',
                        border: '1px solid rgba(255, 255, 255, 0.3)',
                        padding: '6px 10px',
                        height: '32px',
                        backdropFilter: 'blur(4px)'
                      }
                    },
                    input: {
                      style: {
                        padding: '0',
                        fontSize: '0.8rem',
                        color: '#fff',
                        fontWeight: '500'
                      }
                    },
                    trigger: {
                      style: {
                        color: '#fff',
                        width: '20px'
                      }
                    },
                    item: ({ context }: any) => ({
                      style: {
                        padding: '8px 12px',
                        fontSize: '0.875rem',
                        backgroundColor: context.selected ? '#e3f2fd' : 'transparent',
                        color: context.selected ? '#1976d2' : '#495057'
                      }
                    })
                  }}
                />
              </div>
              <div className="font-bold" style={{ fontSize: '2.5rem', lineHeight: '1', color: '#fff', fontWeight: '700' }}>{overviewStats.pendingAgreement}</div>
            </div>
          </div>
          <div style={{ flex: '1 1 calc(25% - 0.75rem)', minWidth: '200px' }}>
            <div className="card" style={{
              backgroundImage: 'linear-gradient(135deg, #0288d1 0%, #26c6da 100%)',
              color: '#fff',
              borderRadius: '16px',
              padding: '1.25rem',
              textAlign: 'center',
              minHeight: '110px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              boxShadow: '0 4px 6px -1px rgba(2, 136, 209, 0.2), 0 2px 4px -1px rgba(2, 136, 209, 0.1)',
              border: 'none',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              cursor: 'pointer'
            }} onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(2, 136, 209, 0.3), 0 4px 6px -2px rgba(2, 136, 209, 0.2)';
              e.currentTarget.style.transform = 'translateY(-4px) scale(1.02)';
            }} onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(2, 136, 209, 0.2), 0 2px 4px -1px rgba(2, 136, 209, 0.1)';
              e.currentTarget.style.transform = 'translateY(0) scale(1)';
            }}>
              <div className="flex justify-content-between align-items-center mb-3">
                <span className="font-medium" style={{ fontSize: '0.875rem', color: '#fff', opacity: 0.95 }}>
                  Bản nháp
                </span>
                <Dropdown
                  options={monthOptions}
                  value={draftLastNMonth}
                  onChange={(e) => setDraftLastNMonth(e.value)}
                  optionLabel="label"
                  optionValue="value"
                  style={{
                    width: '100px',
                    height: '32px'
                  }}
                  panelStyle={{
                    fontSize: '0.875rem',
                    padding: '4px 0',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                  }}
                  pt={{
                    root: {
                      style: {
                        background: 'rgba(255, 255, 255, 0.25)',
                        borderRadius: '6px',
                        border: '1px solid rgba(255, 255, 255, 0.3)',
                        padding: '6px 10px',
                        height: '32px',
                        backdropFilter: 'blur(4px)'
                      }
                    },
                    input: {
                      style: {
                        padding: '0',
                        fontSize: '0.8rem',
                        color: '#fff',
                        fontWeight: '500'
                      }
                    },
                    trigger: {
                      style: {
                        color: '#fff',
                        width: '20px'
                      }
                    },
                    item: ({ context }: any) => ({
                      style: {
                        padding: '8px 12px',
                        fontSize: '0.875rem',
                        backgroundColor: context.selected ? '#e3f2fd' : 'transparent',
                        color: context.selected ? '#1976d2' : '#495057'
                      }
                    })
                  }}
                />
              </div>
              <div className="font-bold" style={{ fontSize: '2.5rem', lineHeight: '1', color: '#fff', fontWeight: '700' }}>{overviewStats.draftAgreement}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Biểu đồ */}
      <div className="col-12">
        <h3 className="mb-3" style={{ fontWeight: 'bold', color: 'var(--text-color)' }}>Biểu đồ</h3>
        <div className="grid">
          <div className="col-12 lg:col-8">
            <div className="card">
              <div className="flex justify-content-between align-items-center mb-3">
                <h5>Số lượng tài liệu sử dụng theo thời gian</h5>
                <div className="flex align-items-center">
                  <InputNumber allowEmpty={false} className="config-input mr-2" value={textValue} onChange={(e) => setTextValue(e.value)} locale="vi-VN" min={1} max={24} />
                  <span>Tháng gần đây</span>
                </div>
              </div>
              <div className="p-card-content">
                <Chart type="line" data={chartData} options={chartOptions} />
              </div>
            </div>
          </div>
          <div className="col-12 lg:col-4">
            <div className="card">
              <div className="flex justify-content-between align-items-center mb-3">
                <h5>Tình hình sử dụng tài liệu</h5>
                <Dropdown className="p-dropdown-dasdboard" options={ReportPeriods} value={timesCircle} onChange={(e) => setTimesCircle(e.value)} optionLabel="label" />
              </div>
              <div className="p-card-content">
                <Chart type="pie" data={chartCircleData} options={chartCircleOptions} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const ReportPeriods = [
  { value: 'THISWEEK', label: 'Tuần này' },
  { value: 'THISMONTH', label: 'Tháng này' },
  { value: 'THISFISCALQUARTER', label: 'Quý này' },
  { value: 'THISFISCALYEAR', label: 'Năm nay' },
  { value: 'FIRSTSIXMONTH', label: '6 tháng đầu năm' },
  { value: 'LASTSIXMONTH', label: '6 tháng cuối năm' },
  { value: 'JAN', label: 'Tháng 1' },
  { value: 'FEB', label: 'Tháng 2' },
  { value: 'MAR', label: 'Tháng 3' },
  { value: 'APR', label: 'Tháng 4' },
  { value: 'MAY', label: 'Tháng 5' },
  { value: 'JUN', label: 'Tháng 6' },
  { value: 'JUL', label: 'Tháng 7' },
  { value: 'AUG', label: 'Tháng 8' },
  { value: 'SEP', label: 'Tháng 9' },
  { value: 'OCT', label: 'Tháng 10' },
  { value: 'NOV', label: 'Tháng 11' },
  { value: 'DEC', label: 'Tháng 12' },
  { value: 'FISCALQUARTER1', label: 'Quý I' },
  { value: 'FISCALQUARTER2', label: 'Quý II' },
  { value: 'FISCALQUARTER3', label: 'Quý III' },
  { value: 'FISCALQUARTER4', label: 'Quý IV' },
  { value: 'LASTWEEK', label: 'Tuần trước' },
  { value: 'LASTMONTH', label: 'Tháng trước' },
  { value: 'LASTFISCALQUARTER', label: 'Quý trước' },
  { value: 'LASTFISCALYEAR', label: 'Năm trước' }
];